export default __webpack_public_path__ + "static/media/noimage.fee82e22.png";